import {
	GlobalFooter,
	type CustomSection,
	type SocialLinkItem,
} from '@ds-mgnl/marketing';
import { type ImageProps } from '@dsx/react';
import footerLogo from '../../assets/images/ds-logo-color.svg';

export const Footer = () => {
	const logo: ImageProps = {
		src: footerLogo,
		alt: 'Direct Supply Logo',
	};

	const socialLinks: SocialLinkItem[] = [
		{
			href: 'https://www.facebook.com/directsupply',
			site: 'facebook',
		},
		{
			href: 'https://twitter.com/_DirectSupply',
			site: 'twitterX',
		},
		{
			href: 'http://www.linkedin.com/company/direct-supply',
			site: 'linkedin',
		},
		{
			href: 'http://www.youtube.com/c/directsupply',
			site: 'youtube',
		},
	];

	const customSections: CustomSection[] = [
		{
			section: {
				title: 'DSSI',
			},
			linkGroups: [
				{
					title: 'Procure to Pay',
					links: [
						{
							href: '/solutions/procure-to-pay/ap-automation',
							children: 'AP Automation',
						},
						{
							href: '/solutions/procure-to-pay/inventory-management',
							children: 'Inventory Management',
						},
						{
							href: '/solutions/procure-to-pay/supply-chain-management',
							children: 'Supply Chain Management',
						},
					],
				},
				{
					title: 'Spend Optimization',
					links: [
						{
							href: '/solutions/spend-optimization/supply-chain-consulting',
							children: 'Supply Chain Consulting',
						},
						{
							href: '/solutions/spend-optimization/ai-in-procurement',
							children: 'AI in Procurement',
						},
						{
							href: '/solutions/spend-optimization/food-procurement',
							children: 'Food Procurement',
						},
					],
				},
				{
					links: [
						{ href: '/resources/blogs', children: 'Expertise' },
						{
							href: '/resources/case-studies',
							children: 'Success Stories',
						},
						{
							href: '/contact',
							children: 'Get in Touch',
						},
						{
							href: 'https://www.directs.com/dssi/default.aspx',
							children: 'Sign In',
							target: '_blank',
						},
					],
				},
			],
		},
	];

	return (
		<>
			<GlobalFooter
				logo={logo}
				socialLinks={socialLinks}
				customSections={customSections}
			/>
		</>
	);
};
